var map = {
	"./colossus/cabins/porteA_lock.svg": "45e4",
	"./colossus/cabins/porteA_unlock.svg": "4295",
	"./colossus/cabins/porteB_lock.svg": "5330",
	"./colossus/cabins/porteB_unlock.svg": "502f",
	"./colossus/cabins/porteC_lock.svg": "9918",
	"./colossus/cabins/porteC_unlock.svg": "5236",
	"./colossus/cabins/porteD_lock.svg": "4d3e",
	"./colossus/cabins/porteD_unlock.svg": "4582",
	"./colossus/interpolice/interpolice_logo_complet.svg": "c675",
	"./colossus/webmail/back_icon.svg": "761a",
	"./colossus/webmail/pandamail_logo.svg": "2d71",
	"./colossus/webmail/user_icon.svg": "1c51",
	"./ghosts/daily/daily_yorkshire_logo.svg": "1879",
	"./ghosts/horizon/horizon_cart.svg": "a897",
	"./ghosts/horizon/horizon_logo.svg": "c6e2",
	"./ghosts/hotel/select_arrow.svg": "2241",
	"./ghosts/hunters/play.svg": "7b11",
	"./ghosts/ouija/board.svg": "88a8",
	"./ghosts/ouija/drop.svg": "3c19",
	"./ghosts/ouija/ouroboros.svg": "ecda",
	"./ghosts/ouija/planchette.svg": "f4e6",
	"./ghosts/police/police_emblem.svg": "3871",
	"./ghosts/police/police_logo.svg": "0bc6",
	"./ghosts/tarot/selection_arrow.svg": "d591",
	"./ghosts/tarot/selection_arrow_hover.svg": "febe",
	"./ghosts/tourist/logo.svg": "7b7a",
	"./ghosts/tourist/magnify_icon.svg": "48c9",
	"./home.svg": "c6c2",
	"./mykonos/back.svg": "e310",
	"./mykonos/blog/folder.svg": "414b",
	"./mykonos/blog/login_arrow.svg": "be22",
	"./mykonos/blog/mydrive_logo.svg": "222f",
	"./mykonos/blog/return_icon.svg": "3f2f",
	"./mykonos/destinations/airport_pinpoint.svg": "b079",
	"./mykonos/destinations/artemis_pinpoint.svg": "774e",
	"./mykonos/destinations/casino_pinpoint.svg": "d10e",
	"./mykonos/destinations/chronaki_pinpoint.svg": "8a91",
	"./mykonos/destinations/hospital_pinpoint.svg": "4eb4",
	"./mykonos/destinations/luxury_estate_pinpoint.svg": "a6b3",
	"./mykonos/destinations/palace_hotel_pinpoint.svg": "e192",
	"./mykonos/destinations/police_station_pinpoint.svg": "7800",
	"./mykonos/destinations/sangiovani_pinpoint.svg": "5297",
	"./mykonos/flightaway/flight_icon.svg": "6952",
	"./mykonos/flightaway/flightaway_infos.svg": "d9d7",
	"./mykonos/flightaway/flightaway_logo.svg": "db67",
	"./mykonos/flightaway/flightaway_travels.svg": "2afa",
	"./mykonos/research/research_car.svg": "a9eb",
	"./phone/backspace.svg": "88b8",
	"./phone/call.svg": "b5ad",
	"./phone/phone.svg": "a012",
	"./phone/phone_unlocked.svg": "f7fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";